/* GG Typewriter — rotating placeholder for standalone search inputs (bean fpsh).
 *
 * Same contract as the Shop's typewriter in gg-lookup.js (#startTypewriter):
 * pipe-delimited prompts, type → hold → erase loop on the placeholder,
 * pause on focus / resume on blur of an empty field, no-op under
 * prefers-reduced-motion (the static placeholder stays).
 *
 * Binds to `input[data-search-prompts]` — the Shop/Marken pages carry that
 * attribute on <gg-lookup-component>, never on the input, so this script can
 * never double-drive the Shop field. Follow-up: gg-lookup.js delegates here
 * once the pending shop commit lands.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const TYPE = 55, ERASE = 28, HOLD = 1600, BETWEEN = 380;

  document.querySelectorAll('input[data-search-prompts]').forEach((input) => {
    const prompts = (input.dataset.searchPrompts || '')
      .split('|').map((s) => s.trim()).filter(Boolean);
    if (!prompts.length) return;

    const staticPlaceholder = input.getAttribute('placeholder') || '';
    let index = 0;
    let timer = null;

    // Animation runs only while the field is idle (unfocused + empty);
    // otherwise it bails and waits for the blur of an empty field to restart.
    const idle = () => document.activeElement !== input && !input.value;

    const step = (text, pos, phase) => {
      if (!idle()) return;
      if (phase === 'typing') {
        input.setAttribute('placeholder', text.slice(0, pos + 1));
        if (pos + 1 < text.length) {
          timer = setTimeout(() => step(text, pos + 1, 'typing'), TYPE);
        } else {
          timer = setTimeout(() => step(text, text.length, 'erasing'), HOLD);
        }
      } else {
        input.setAttribute('placeholder', text.slice(0, Math.max(pos - 1, 0)));
        if (pos - 1 > 0) {
          timer = setTimeout(() => step(text, pos - 1, 'erasing'), ERASE);
        } else {
          index = (index + 1) % prompts.length;
          timer = setTimeout(() => step(prompts[index], 0, 'typing'), BETWEEN);
        }
      }
    };

    input.addEventListener('focus', () => {
      clearTimeout(timer);
      timer = null;
      // Leave a clean, complete placeholder while the user is in the field.
      input.setAttribute('placeholder', staticPlaceholder);
    });

    input.addEventListener('blur', () => {
      if (input.value) return; // user typed something — keep static, no rotation
      clearTimeout(timer);
      index = 0;
      step(prompts[0], 0, 'typing');
    });

    step(prompts[0], 0, 'typing');
  });
})();
